// IMPORTS
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AnimatedText from './AnimatedText';
import '../../styles/nav.css';
import logo from '../../assets/images/logo-metal-reshape1.png';

// COMPONENT
function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Example: programmatic navigation
  const goToContact = () => {
    navigate('/contact-us');
    setIsOpen(false); // close menu after navigation
  };

  // RETURN USING TAILWIND CLASSES
  return (
    <nav className="p-2">
      <div className="container mx-auto flex justify-between items-center relative">
        {/* Floating logo */}
        <img
          src={logo}
          alt="Logo"
          id="logo"
          className="absolute left-0 top-1/2 -translate-y-1/2"
        />

        {/* Center text */}
        <div className="flex-grow text-center">
          <AnimatedText text="Metal" className="text-2xl font-bold text-white" />
        </div>

        {/* HAMBURGER MENU */}
        <div className="flex-shrink-0">
          <button
            onClick={toggleMenu}
            type="button"
            className="text-white focus:outline-none"
          >
            {isOpen ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            )}
          </button>
        </div>

        {/* LINKS VISIBLE WHEN MENU IS OPEN */}
        <div
          className={`${
            isOpen ? 'block' : 'hidden'
          } w-full md:w-auto mt-4 md:mt-0`}
        >
          <Link
            to="/"
            className="block text-white hover:text-gray-300 py-2 px-4"
            onClick={() => setIsOpen(false)}
          >
            Home Page
          </Link>
          <Link
            to="/team"
            className="block text-white hover:text-gray-300 py-2 px-4"
            onClick={() => setIsOpen(false)}
          >
            Developer Team
          </Link>
          <Link
            to="/promote-and-earn"
            className="block text-white hover:text-gray-300 py-2 px-4"
            onClick={() => setIsOpen(false)}
          >
            Promote & Earn
          </Link>
          {/* Example using useNavigate */}
          <button
            type="button"
            onClick={goToContact}
            className="block text-white hover:text-gray-300 py-2 px-4 text-left w-full"
          >
            Contact Us
          </button>
          {/* <Link
                to="/about"
                className="block text-white hover:text-gray-300 py-2 px-4">
                About Us
             </Link> */}
        </div>
      </div>
    </nav>
  );
}

// EXPORT
export default Nav;
